import { Space } from 'antd'
import { WithRecord } from '../../../../../types'
import {
  useCheckPermissions,
  useCheckPermissionsMap,
} from 'hooks/useCheckPermission'
import { useProjectCustomFieldsContext } from '../../../../../../CustomFields/ProjectCustomFieldsContext'
import { useCIMSTableContext } from '../../../..'
import RestoreRowActionButton from './components/RestoreRowActionButton'
import CustomRowActionButtons from './components/CustomRowActionButtons'
import EditRowActionButton from './components/EditRowActionButton'
import RemoveRowActionButton from './components/RemoveRowActionButton'

export function RowActionButtons<T extends object>({ record }: WithRecord<T>) {
  const { rowKey, actions } = useCIMSTableContext<T>()
  const { editorOnSome } = useProjectCustomFieldsContext()
  const { edit, custom, remove, restore } = actions.row ?? {}
  const canEdit = useCheckPermissions(record)
  const canRemove = useCheckPermissions(record)
  const canRestore = useCheckPermissions(record)
  const [, someAllowed] = useCheckPermissionsMap(
    (custom ?? []).map((custom, key) => {
      if (custom.type === 'externalLink') return { key, permission: true }
      const { permission } = custom
      return typeof permission === 'function'
        ? { key, permission, record }
        : { key, permission }
    })
  )
  const key =
    typeof rowKey === 'function' ? rowKey(record) : String(record[rowKey])
  const removed = restore?.metadata(record)?.removed
  return (
    <Space
      key={`row-action-buttons-${key}`}
      onClick={(e) => e.stopPropagation()}
      style={{ cursor: 'auto' }}
      direction="vertical"
      size={8}
    >
      {edit && (canEdit(edit.permission) || editorOnSome) && !removed && (
        <EditRowActionButton record={record} />
      )}
      {remove && canRemove(remove.permission) && !removed && (
        <RemoveRowActionButton record={record} />
      )}
      {restore && canRestore(restore.permission) && removed && (
        <RestoreRowActionButton record={record} />
      )}
      {custom && someAllowed && <CustomRowActionButtons record={record} />}
    </Space>
  )
}
